import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
/**
 * Merges class names, letting a caller override a component's defaults.
 *
 * `clsx` handles conditionals; `twMerge` resolves Tailwind conflicts so that
 * `cn('px-3', 'px-6')` yields `px-6` rather than both. Without it, component
 * defaults would silently win over the prop a caller passed, which is the
 * usual reason a "why won't this style apply" bug takes an afternoon.
 */
export const cn = (...inputs) => twMerge(clsx(inputs));
//# sourceMappingURL=cn.js.map